let _electron = false;

try{
	const electron = window.require('electron');

	if(electron){
		_electron = true;
		document.body.classList.add('electron');
	}

} catch(e){
	document.body.classList.add('web');
}

export default {electron:_electron};